export const makeArrayEvenLength = (arr) => {
  if (arr.length && arr.length % 2 !== 0) {
    arr.pop();
  }

  return arr;
};
